// import React from 'react'

// const SessionCharges = () => {
//   return (
//     <div>SessionCharges</div>
//   )
// }

// export default SessionCharges


import { useEffect, useState } from "react";
import AddSessionAmountPopup from "components/popus/Settings/session-amount";
import Button from "components/particles/primary-button";
import { setModalOpened } from "store/user-slice";
import { dispatch, RootState } from "store";
import { useSelector } from "react-redux";
import { Container } from "./style";
import { useSessionAmount } from "../session-amount/useHook";
import AddSessionChargesPopup from "components/popus/Settings/session-charges";
import { useSettings } from "containers/setting/useHook";
import usePrevious from "utils/helpers/custom-functions";

type SessionChargesType = {
  id: number;
  adminCharges: number;
  homeCookPenaltyFee: number;
  createdAt?: string;
  updatedAt?: string;
};


export default function SessionCharges() {
  const [data, setData] = useState<SessionChargesType | null>(null);
  const [dataById, setDataById] = useState<any>();
  const [id, setId] = useState<number>(0);
  const { getSessionCharges, postSessionCharges } = useSettings();
  const { sessionAmountModalIsOpen } = useSelector(
    (state: RootState) => state.user
  );
  const prevModalState = usePrevious(sessionAmountModalIsOpen);

  useEffect(() => {
    getSessionCharges(setData);
  }, []);

  const handleChange = (id: number) => {
    dispatch(setModalOpened("Session Amount"));
    setId(id);
    if (id !== 0) {
      // getSessionAmountById(id, setDataById);
    }
  };

  // const chargesId = data?.id
  console.log(data, "data");

  return (
    <Container>
      <div className="title">
        <h1>Set Platform Charges</h1>
        {data?.id ? null : (
          <Button
            title="Add Charge"
            width="22rem"
            fill="true"
            onclick={() => handleChange(0)}
            backgroundcolor="var(--secondary)"
          />
        )}

      </div>

      <div className="amount-container">
        <div className="amount-cart">
          <h1>Platform Charges</h1>
          <div className="amount">
            <p>Admin: {data?.adminCharges}</p>
            <p>$</p>
          </div>
          <div className="amount">
            <p>Home Cook Penalty: {data?.homeCookPenaltyFee}</p>
            <p>$</p>
          </div>
          {typeof data?.id === "number" && (
            <Button
              title="Update"
              width="16rem"
              fill="true"
              backgroundcolor="var(--secondary)"
              onclick={() => handleChange(data.id)}
            />
          )}

        </div>

        {/* );
        })} */}
      </div>

      {sessionAmountModalIsOpen ? (
        <AddSessionChargesPopup data={data} setData={setData} />
      ) : (
        ""
      )}
    </Container>
  );
}
